// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__jpP62","txtSec":"styles_txtSec__ZGUde","ttl":"styles_ttl__Bq95v","txt":"styles_txt__0zkTB","img":"styles_img__MPV4y"};